import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import { createContext, useContext, useMemo } from 'react';
import { useMatch } from 'react-router-dom';
import { AuthContext } from 'libs.react';
import { getApiInstance } from '../../helpers/api.helpers';
import { useCurrentEnvironment } from '../../hooks/use_current_environment';
import { CortexSessionHandlerContext } from '../cortex_session_handler/cortex_session_handler.context';
export const AxonAccountContext = createContext({
    isLoading: true,
    account: null,
});
export const AxonAccountProvider = ({ children }) => {
    const match = useMatch('/site/study/:studyId/*');
    const { user } = useContext(AuthContext);
    const { cortexSessionData } = useContext(CortexSessionHandlerContext);
    const { environment } = useCurrentEnvironment(match?.params?.studyId);
    const getAxonAccount = async () => {
        if (!environment) {
            return;
        }
        if (cortexSessionData) {
            return cortexSessionData;
        }
        const { data: response } = await getApiInstance(environment).get(`/v2/hub/accounts/login`);
        return response || null;
    };
    const { data: account, isLoading } = useQuery({
        queryKey: ['getAxonAccount', environment?.id?.toString(), user?.id.toString()],
        queryFn: getAxonAccount,
        enabled: !!environment && !!user?.id,
    });
    const value = useMemo(() => ({
        isLoading,
        account,
    }), [account, user?.id]);
    return _jsx(AxonAccountContext.Provider, { value: value, children: children });
};
